import { produce } from 'immer';

import type { CouponIndex } from '../../../../../schema/coupon/entry.js';
import { entriesFromObject } from '../../../../../schema/utils/entry.js';
import type { CouponState } from '../../../../domain/entry.js';

/**
 * Filters out all coupons that are not modified.
 * This is used as a writer function for the the local storage middleware in Zustand Coupon store.
 *
 * @param state Partial state of the Coupon store
 * @param callback Callback to update the state
 */
export function filterModifiedCoupons(
  state: Pick<CouponState, 'Coupons' | 'ModifiedCoupons' | 'Wallets'>,
  callback: (state: Pick<CouponState, 'Coupons' | 'ModifiedCoupons' | 'Wallets'>) => void
): void {
  const persistState = produce(state, (draftState) => {
    for (const [couponId] of entriesFromObject(draftState.Coupons)) {
      const draftCoupons = draftState.Coupons[couponId];

      if (!draftCoupons || draftCoupons.length === 0) {
        continue;
      }

      for (const draftCoupon of draftCoupons) {
        // Don't ever write the boards property from a external game to local storage
        const couponIndex = draftCoupons.indexOf(draftCoupon) as CouponIndex;
        if (draftCoupon.couponType === 'external_system') {
          draftCoupon.boards = [];
        }
        const isCouponModified = draftState.ModifiedCoupons[couponId]?.includes(couponIndex);
        if (!isCouponModified) {
          draftState.Coupons[couponId]?.splice(couponIndex, 1);
        }
      }
      if (draftCoupons.length === 0) {
        // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete draftState.Coupons[couponId];
      }
    }
  });

  callback({ Coupons: persistState.Coupons, ModifiedCoupons: {}, Wallets: persistState.Wallets });
}
